import {all, call, fork, put, select, take, takeEvery} from 'redux-saga/effects';
import {END, eventChannel, EventChannel} from 'redux-saga';
import IRestServiceCollectionResponse from "../../model/interface/api/IRestServiceCollectionResponse";
import {env} from "../../configs/EnvironmentConfig";
import StreamEventsService, {IStreamServiceResponse} from "../../model/service/api/StreamEventsService";
import {STREAM_EVENTS_ERROR, STREAM_EVENTS_LOAD} from "../constants/StreamEvents";
import {save} from "../actions/StreamEvents";
import {reLoad} from "../actions/Setup";
import SettingsService from "../../model/service/SettingsService";
import {IAppState} from "../store";

let currentEventChannel: EventChannel<IRestServiceCollectionResponse> | null = null;
let intentionalClose: boolean = false;

function createEventChannel(token: string): EventChannel<IRestServiceCollectionResponse> {
    return eventChannel<IRestServiceCollectionResponse>((emitter) => {
        const eventSource = new EventSource(env.API_ENDPOINT_URL + '/stream-events?token=' + token);

        eventSource.onmessage = (event) => {
            try {
                const data = JSON.parse(event.data);
                emitter(data);
            } catch (error) {
                console.error('Error parsing event data:', error);
            }
        };

        eventSource.onerror = (error) => {
            console.error('EventSource error:', error);
            emitter(END); // Signal the channel to close
        };

        return () => {
            eventSource.close();
        };
    });
}

function* handleEventSource(token: string) {
    // @ts-ignore
    const channel = yield call(createEventChannel, token);
    currentEventChannel = channel; // Store the current channel

    try {
        while (true) {
            const data: IStreamServiceResponse = yield take(channel)
            const state: IAppState = (yield select());
            const previousSetup = state.streamEvents.setup
            yield put(save(data)); // Dispatch the save action
            if (previousSetup && data['setup'] && data['setup'] !== previousSetup  && SettingsService.getValue('ui', 'setupUpdate') === 'auto'){
                yield put(reLoad(true, false))
            }
        }
    } catch (error) {
        console.error('handleEventSource error:', error);
    } finally {
        channel.close();
        currentEventChannel = null; // Clear the channel
        yield put({ type: STREAM_EVENTS_ERROR }); // Dispatch error action
    }
}

export function* streamEventsLoad() {
    try {
        if (currentEventChannel) {
            intentionalClose = true; // Set the flag before closing
            currentEventChannel.close();
            currentEventChannel = null;
        }

        const response: IStreamServiceResponse = yield call(StreamEventsService.setup, { limit: 100, cache: false });
        const token = response['sse_token'];
        if (token) {
            yield fork(handleEventSource, token); // Fork the event source handling
        }
        yield put(save(response));
    } catch (error) {
        console.error('streamEvents error:', error);
    }
}

export function* watchStreamEventsError() {
    yield takeEvery(STREAM_EVENTS_ERROR, function* () {
        if (!intentionalClose) {
            yield call(streamEventsLoad);
        }
    });
}

export function* watchStreamEventsLoad() {

    yield takeEvery(STREAM_EVENTS_LOAD, streamEventsLoad);
}

export default function* rootSaga() {
    yield all([
        fork(watchStreamEventsLoad),
        fork(watchStreamEventsError)
    ]);
}